import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API_BASE,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add auth token interceptor
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Handle 401 errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

// Auth
export const login = async (username, password) => {
    const response = await api.post('/auth/login', { username, password });
    return response.data;
};

export const getMe = async (token) => {
    const response = await axios.get(`${API_BASE}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
};

// Usuarios
export const getUsuarios = () => api.get('/usuarios');
export const createUsuario = (data) => api.post('/usuarios', data);
export const updateUsuario = (id, data) => api.put(`/usuarios/${id}`, data);
export const deleteUsuario = (id) => api.delete(`/usuarios/${id}`);

// Dashboard
export const getDashboardStats = () => api.get('/dashboard/stats');

// Marcas
export const getMarcas = (params) => api.get('/marcas', { params });
export const getMarcasCount = (params) => api.get('/marcas/count', { params });
export const getMarca = (id) => api.get(`/marcas/${id}`);
export const createMarca = (data) => api.post('/marcas', data);
export const updateMarca = (id, data) => api.put(`/marcas/${id}`, data);
export const deleteMarca = (id) => api.delete(`/marcas/${id}`);
export const reorderMarcas = (items) => api.put('/reorder/marcas', items);

// Tipos Producto
export const getTiposProducto = (params) => api.get('/tipos-producto', { params });
export const getTiposProductoCount = (params) => api.get('/tipos-producto/count', { params });
export const getTipoProducto = (id) => api.get(`/tipos-producto/${id}`);
export const createTipoProducto = (data) => api.post('/tipos-producto', data);
export const updateTipoProducto = (id, data) => api.put(`/tipos-producto/${id}`, data);
export const deleteTipoProducto = (id) => api.delete(`/tipos-producto/${id}`);
export const reorderTiposProducto = (items) => api.put('/reorder/tipos-producto', items);

// Entalles
export const getEntalles = (params) => api.get('/entalles', { params });
export const getEntallesCount = (params) => api.get('/entalles/count', { params });
export const getEntalle = (id) => api.get(`/entalles/${id}`);
export const createEntalle = (data) => api.post('/entalles', data);
export const updateEntalle = (id, data) => api.put(`/entalles/${id}`, data);
export const deleteEntalle = (id) => api.delete(`/entalles/${id}`);
export const reorderEntalles = (items) => api.put('/reorder/entalles', items);

// Telas
export const getTelas = (params) => api.get('/telas', { params });
export const getTelasCount = (params) => api.get('/telas/count', { params });
export const getTela = (id) => api.get(`/telas/${id}`);
export const createTela = (data) => api.post('/telas', data);
export const updateTela = (id, data) => api.put(`/telas/${id}`, data);
export const deleteTela = (id) => api.delete(`/telas/${id}`);
export const reorderTelas = (items) => api.put('/reorder/telas', items);

// Clasificaciones Tela
export const getClasificacionesTela = () => api.get('/clasificaciones-tela');
export const createClasificacionTela = (data) => api.post('/clasificaciones-tela', data);
export const updateClasificacionTela = (id, data) => api.put(`/clasificaciones-tela/${id}`, data);
export const deleteClasificacionTela = (id) => api.delete(`/clasificaciones-tela/${id}`);
export const reorderClasificacionesTela = (items) => api.put('/reorder/clasificaciones-tela', items);

// Hilos
export const getHilos = (params) => api.get('/hilos', { params });
export const getHilosCount = (params) => api.get('/hilos/count', { params });
export const getHilo = (id) => api.get(`/hilos/${id}`);
export const createHilo = (data) => api.post('/hilos', data);
export const updateHilo = (id, data) => api.put(`/hilos/${id}`, data);
export const deleteHilo = (id) => api.delete(`/hilos/${id}`);
export const reorderHilos = (items) => api.put('/reorder/hilos', items);

// Estados Costura
export const getEstadosCostura = (params) => api.get('/estados-costura', { params });
export const createEstadoCostura = (data) => api.post('/estados-costura', data);
export const updateEstadoCostura = (id, data) => api.put(`/estados-costura/${id}`, data);
export const deleteEstadoCostura = (id) => api.delete(`/estados-costura/${id}`);
export const reorderEstadosCostura = (items) => api.put('/reorder/estados-costura', items);

// Avios Costura
export const getAviosCostura = (params) => api.get('/avios-costura', { params });
export const createAvioCostura = (data) => api.post('/avios-costura', data);
export const updateAvioCostura = (id, data) => api.put(`/avios-costura/${id}`, data);
export const deleteAvioCostura = (id) => api.delete(`/avios-costura/${id}`);
export const reorderAviosCostura = (items) => api.put('/reorder/avios-costura', items);

// Muestras Base
export const getMuestrasBase = (params) => api.get('/muestras-base', { params });
export const getMuestrasBaseCount = (params) => api.get('/muestras-base/count', { params });
export const getMuestraBase = (id) => api.get(`/muestras-base/${id}`);
export const createMuestraBase = (data) => api.post('/muestras-base', data);
export const updateMuestraBase = (id, data) => api.put(`/muestras-base/${id}`, data);
export const deleteMuestraBase = (id) => api.delete(`/muestras-base/${id}`);
export const uploadArchivoCostos = (id, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/muestras-base/${id}/archivo`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};
export const deleteArchivoCostos = (id) => api.delete(`/muestras-base/${id}/archivo`);

// Fichas
export const getFichas = (params) => api.get('/fichas', { params });
export const getFichasCount = (params) => api.get('/fichas/count', { params });
export const getFicha = (id) => api.get(`/fichas/${id}`);
export const createFicha = (data) => api.post('/fichas', data);
export const updateFicha = (id, data) => api.put(`/fichas/${id}`, data);
export const deleteFicha = (id) => api.delete(`/fichas/${id}`);
export const uploadArchivoFicha = (id, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/fichas/${id}/archivo`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};

// Tizados
export const getTizados = (params) => api.get('/tizados', { params });
export const getTizadosCount = (params) => api.get('/tizados/count', { params });
export const getTizado = (id) => api.get(`/tizados/${id}`);
export const createTizado = (data) => api.post('/tizados', data);
export const updateTizado = (id, data) => api.put(`/tizados/${id}`, data);
export const deleteTizado = (id) => api.delete(`/tizados/${id}`);
export const uploadArchivoTizado = (id, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/tizados/${id}/archivo`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};

// Bases
export const getBases = (params) => api.get('/bases', { params });
export const getBasesCount = (params) => api.get('/bases/count', { params });
export const getBase = (id) => api.get(`/bases/${id}`);
export const createBase = (data) => api.post('/bases', data);
export const updateBase = (id, data) => api.put(`/bases/${id}`, data);
export const deleteBase = (id) => api.delete(`/bases/${id}`);
export const uploadPatron = (id, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/bases/${id}/patron`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};
export const uploadImagen = (id, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/bases/${id}/imagen`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};
export const uploadFichasBase = (id, files, nombres = []) => {
    const formData = new FormData();
    files.forEach(file => formData.append('files', file));
    nombres.forEach(nombre => formData.append('nombres', nombre));
    return api.post(`/bases/${id}/fichas`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};
export const uploadFichaChecklist = (id, file, nombre) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('nombre', nombre);
    return api.post(`/bases/${id}/fichas-checklist`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};
export const generateChecklistPdf = (baseId, items, title) => {
    return api.post(`/bases/${baseId}/generate-checklist`, { items, title });
};
export const regenerarTodosPdfs = () => api.post('/bases/regenerar-pdfs');
export const deleteFichaBase = (id, fileIndex) => api.delete(`/bases/${id}/fichas/${fileIndex}`);
export const uploadTizadosBase = (id, files, nombres = []) => {
    const formData = new FormData();
    files.forEach(file => formData.append('files', file));
    nombres.forEach(nombre => formData.append('nombres', nombre));
    return api.post(`/bases/${id}/tizados`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};
export const deleteTizadoBase = (id, fileIndex) => api.delete(`/bases/${id}/tizados/${fileIndex}`);
export const reorderBases = (items) => api.put('/reorder/bases', items);

// Modelos
export const getModelos = (params) => api.get('/modelos', { params });
export const getModelosCount = (params) => api.get('/modelos/count', { params });
export const getModelo = (id) => api.get(`/modelos/${id}`);
export const createModelo = (data) => api.post('/modelos', data);
export const updateModelo = (id, data) => api.put(`/modelos/${id}`, data);
export const deleteModelo = (id) => api.delete(`/modelos/${id}`);
export const reorderModelos = (items) => api.put('/reorder/modelos', items);
export const uploadFichaModelo = (id, files, nombres = []) => {
    const formData = new FormData();
    files.forEach(file => formData.append('files', file));
    nombres.forEach(nombre => formData.append('nombres', nombre));
    return api.post(`/modelos/${id}/fichas`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};
export const deleteFichaModelo = (id, fileIndex) => api.delete(`/modelos/${id}/fichas/${fileIndex}`);

// Reportes
export const getReporteModelos = () => api.get('/reportes/modelos');

export const downloadModeloFiles = (id) => {
    const token = localStorage.getItem('token');
    return `${API_BASE}/modelos/${id}/descargar?token=${encodeURIComponent(token)}`;
};

// File download URL helper - handles both local and R2 paths
export const getFileUrl = (filePath) => {
    if (!filePath) return '';
    
    // If path starts with r2://, use the R2 endpoint
    if (filePath.startsWith('r2://')) {
        const key = filePath.substring(5); // Remove 'r2://' prefix
        return `${API_BASE}/files/${key}`;
    }
    
    // Regular local file path
    return `${API_BASE}/files/${filePath}`;
};

export default api;
